import { InventoryIssueFormData, InventoryIssueRow } from './types';

export const issueStatusOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'draft', name: 'Nháp' },
  { id: 'approved', name: 'Đã duyệt' },
  { id: 'posted', name: 'Đã ghi sổ' },
  { id: 'inactive', name: 'Ngưng dùng' },
];

export const inventoryIssueRows: InventoryIssueRow[] = [];

export const createDefaultIssueForm = (companyId: string): InventoryIssueFormData => ({
  code: '',
  name: '',
  order_no: '',
  order_id: '',
  store_id: '',
  store_name: '',
  status: 'draft',
  status_is_posted: false,
  amount: '',
  company_id: companyId,
  note: '',
  issued_at: new Date().toISOString().slice(0, 10),
  lines: [],
});